import React from "react";

const BrandLogo = () => {
	return (
		<svg
			version='1.1'
			id='Layer_1'
			xmlns='http://www.w3.org/2000/svg'
			xlinkHref='http://www.w3.org/1999/xlink'
			x='0px'
			y='0px'
			width='48px'
			height='48px'
			viewBox='0 0 48 48'
			enableBackground='new 0 0 48 48'
			xmlSpace='preserve'>
			<image
				id='image0'
				width='48'
				height='48'
				x='0'
				y='0'
				href='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAABGdBTUEAALGPC/xhBQAAACBjSFJN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'
			/>
		</svg>
	);
};

export default BrandLogo;
